import {CompanyPortalParams} from 'domain/usecases/public/sign-in/company-portal';
import {makeRemoteGetCompanyPortal} from 'main/factories/usecases/public/remote-b2b-sign-in/get-company-portal';

export const getCompanyPortal = async (params: CompanyPortalParams) =>
	makeRemoteGetCompanyPortal().get(params);
